import React, { Component } from 'react';

interface Props {
	containerId: string;
	children: React.ReactNode;
}

if (typeof window !== 'undefined') {
	// @ts-expect-error dynamically added
	window.dataLayer = [
		{
			'gtm.start': new Date().getTime(),
			event: 'gtm.js',
		},
	];
}

export default class GoogleTagManager extends Component<Props> {
	scriptElement: HTMLScriptElement = document.createElement('script');

	componentDidMount() {
		this.scriptElement.async = true;
		this.scriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(this.props.containerId)}`;

		if (document.head) {
			document.head.appendChild(this.scriptElement);
		}
	}

	componentWillUnmount() {
		const { parentElement } = this.scriptElement;
		if (parentElement) {
			parentElement.removeChild(this.scriptElement);
		}
	}

	render() {
		return <>{this.props.children}</>;
	}
}
